import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'd-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './d-button.component.html',
  styleUrl: './d-button.component.scss',
})
export class DButtonComponent {
  @Input() type: 'button' | 'submit' = 'button';
  @Input() buttonClasses: string[] = [];

  get cssClasses() {
    return ['button', ...this.buttonClasses];
  }
}
